module.exports = "/static/assets/af8bfc90dc5221c4f55825196b6c6776.png";